import { Box, IconButton, Stack, Typography } from '@mui/joy';


const listGif = [
    {
        id: 1,
        width: 120,
        gif: "./gifs/Cat_Kitty_GIF.gif"
    },
    {
        id: 2,
        width: 200,
        gif: "./gifs/Homer_loading_GIF.gif"
    },
    {
        id: 3,
        width: 140,
        gif: "./gifs/Happy_Dance_GIF_by.gif"
    },
    {
        id: 4,
        width: 200,
        gif: "./gifs/Sesame_Street_Waiting_Muppet_Wiki.gif"
    },
    {
        id: 5,
        width: 150,
        gif: "./gifs/Sleepy_Coffee_Time_Pudgy_Penguins.gif"
    },
    {
        id: 6,
        width: 150,
        gif: "./gifs/Computer_Game_Work_TRT.gif"
    },
    {
        id: 7,
        width: 150,
        gif: "./gifs/Thinking_Charging.gif"
    },
    {
        id: 8,
        width: 150,
        gif: "./gifs/Looking_Turn_Around.gif"
    },
    {
        id: 9,
        width: 150,
        gif: "./gifs/No_Brain_Waiting_Sappy_Seals.gif"
    },
    {
        id: 10,
        width: 200,
        gif: "./gifs/summer_2016_waiting.gif"
    }
]



const LoadingBlockGif = ({ text = null }) => {
    function getRandomInt(max) {
        return Math.floor(Math.random() * max);
    }

    const dataG = listGif[getRandomInt(10)];

    return (
        <Stack direction={"column"} spacing={2} alignItems={"center"}>
            <img src={dataG.gif} width={dataG.width} />
            <Typography level="h4">
                {text}
            </Typography>
        </Stack>
    );
};


export default LoadingBlockGif;